import dayjs from 'dayjs'
import type { RouteItem } from '../../types'

export const tableCols = (step: RouteItem) => [
  {
    label: 'Projected',
    value: {
      start: step.projected_start_time,
      end: step.projected_end_time,
    },
  },
  {
    label: 'Manual',
    value: {
      start: step.manual_start_time,
      end: step.manual_end_time,
    },
  },
  {
    label: 'GPS',
    value: {
      start: step.gps_start_event?.date,
      end: step.gps_end_event?.date,
    },
  },
]

export function groupStepsByOrder(steps: RouteItem[]) {
  const orderGroups: Record<
    number,
    {
      firstIndex: number
      steps: RouteItem[]
    }
  > = {}

  if (!steps || steps.length === 0) {
    return orderGroups // Return empty object if no steps
  }

  steps.forEach((step, index) => {
    const key = step.order_number
    if (key === null || key === undefined) {
      return // Skip steps without an order number
    }

    if (!orderGroups[key]?.steps) {
      orderGroups[key] = {
        firstIndex: index,
        steps: [],
      }
    }
    orderGroups[key].steps.push(step)
  })
  return orderGroups
}

export function getTimeDelta(start1: string, end1: string, start2: string, end2: string): string {
  // Calculate duration of first period
  const period1Duration = dayjs(end1).diff(dayjs(start1), 'minutes')

  // Calculate duration of second period
  const period2Duration = dayjs(end2).diff(dayjs(start2), 'minutes')

  // Calculate the difference (positive = increase, negative = decrease)
  const diffMinutes = period2Duration - period1Duration
  const isIncrease = diffMinutes >= 0

  // Convert to hours and minutes
  const absDiffMinutes = Math.abs(diffMinutes)
  const hours = Math.floor(absDiffMinutes / 60)
  const minutes = absDiffMinutes % 60

  // Format the result
  const sign = isIncrease ? '+' : '-'
  const timeString = hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`
  const formatted = `${sign}${timeString}`

  return formatted
}
